import React from 'react';
import { Alert } from 'react-bootstrap';

function AlertGen(props) {
    const variant = props.isFailure === true ? 'danger' : 'success';
    const header_message = props.isFailure === true ? 'Oh snap! You got an error!' : 'Oh yeah! Success!';
    
    if (props.show) {
        console.log(props.isFailure)
        return (
        <Alert onClose={props.onHide} variant={variant} dismissible>
          <Alert.Heading>{header_message}</Alert.Heading>
          <p>
            {props.message}
          </p>
        </Alert>
      );
    }
    return null;
  }

export default AlertGen;